/* src/app/shared-components/loader/loader.component.scss */
/*# sourceMappingURL=loader.component.css.map */
